<template>
  <div id="body" v-title data-title="分销商 | 注册">
    <header>
      <a href class="banner-link">立即注册，赚取佣金</a>
    </header>

    <div class="page">
      <div class="weui-cells weui-cells_form">
        <div class="weui-cell weui-cell_vcode">
          <div class="weui-cell__bd">
            <input class="weui-input phone" type="tel" placeholder="请输入手机号" v-model="user.UserName" />
          </div>
        </div>
        <div class="weui-cell weui-cell_vcode">
          <div class="weui-cell__bd">
            <input class="yzm" type="text" placeholder="验证码" v-model="PicCodeValue" />
          </div>
          <img
            v-bind:src="'data:image/png;base64,'+VerificationCodePic.Base64"
            style="width:25%;margin-right:3%"
            @click="getpiccode()"
          />
        </div>
        <div class="weui-cell weui-cell_vcode">
          <div class="weui-cell__bd">
            <input class="yzm" type="tel" placeholder="请输入验证码" v-model="user.Password" />
            <div class="btn-vercode">
              <button
                class="weui-btn weui-btn_mini btn-orange"
                style="width:inherit"
                v-if="getcodeshow&&user.UserName.length==11"
                @click="getcode(3)"
              >获取验证码</button>
              <button
                class="weui-btn weui-btn_mini btn-orange"
                style="width:inherit"
                v-if="getcodeshow&&user.UserName.length!=11"
              >获取验证码</button>
              <button
                class="weui-btn weui-btn_mini btn-orange"
                style="width:inherit;background-color:#ccc"
                v-if="!getcodeshow"
              >{{waitminutes}}秒</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="weui-btn-area">
      <a class="weui-btn weui-btn_primary btn-login" @click="checkcode()" href="javascript:">立即注册</a>
    </div>

    <div class="weui-footer weui-footer_fixed-bottom">
      <p class="weui-footer__links" style="margin:10px auto;">
        <!--默认国旅家游客-->
        <a href="/#/account/login?type=dis" class="weui-footer__link register">已有账号？立即登录</a>
      </p>
    </div>
  </div>
</template>
<script>
import { Toast } from "we-vue";
import { Dialog } from "we-vue";

export default {
  name: "mdisreg",
  data() {
    return {
      loginType: 4,
      user: { UserName: "", Password: "" },
      getcodeshow: true,
      waitminutes: "",
      codetimer: null,
      VerificationCodePic: { OnceString: "" }, //图形验证码信息
      PicCodeValue: "", //图形验证码值
      formset: {},
      companyId: 0,
      wxcode: "",
      disid: ""
    };
  },
  mounted: function() {
    this.companyId = this.$route.query.id;
    this.disid = this.$route.query.disid;
    if (this.disid == undefined || this.disid == null||this.disid=="undefined") {
      this.disid == "";
    }
    var url = window.location.href;
    var code = this.GetRequest(url)["code"];
    if (code == undefined || code == null || code == "") {
      //先授权微信公众号
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        this.GLOBAL.appid +
        "&redirect_uri=" +
        this.GLOBAL.redirect_uri +
        "%23%2Fpage%2Fmdisreg%3Fid%3D" +
        this.companyId +
        "%26disid%3D" +
        this.disid +
        "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      //绑定微信
      console.info(code);
    } else {
      this.wxcode = code;
      this.RegDisByWechat(code);
    }
    this.getpiccode();
  },
  methods: {
    BindWechat: function(code) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/bindwechat", {
          params: {
            code: code
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            //绑定成功
            Toast.success("注册成功");
            window.location.href = this.GLOBAL.WEB_URL + "/#/app/home";
          } else {
            Toast.fail(rep.Message);
          }
        });
    },

    RegDisByWechat: function(code) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/regdisbywechat", {
          params: {
            code: code,
            type: 4
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.formset = rep.Data;
            //未关注微信公众号，跳转到一键关注公众号页
            // if (rep.Data.subscribe == 0) {
            //   Dialog.alert({
            //     title: "提示信息",
            //     message: "请先关注壹选生活微信公众号"
            //   }).then(() => {
            //     window.location.href =
            //       "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU4NzgwMTY2OQ==#wechat_redirect";
            //   });
            // }
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    setcache: function() {
      var promise = this.$http.get(this.GLOBAL.BASE_URL + "api/getdict");
      promise.then(function(d) {
        var rep = JSON.parse(d.bodyText);
        if (rep.Success) {
          localStorage.setItem("cachedict", JSON.stringify(rep.Data));
        } else {
          Toast.fail(rep.Message);
        }
      });
    },
    //获取图形验证码
    getpiccode: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getverificationcodepic", {
          params: { codeGuid: this.VerificationCodePic.OnceString }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.VerificationCodePic = rep.Data;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    getcode: function() {
      if (this.user.UserName == "") {
        Toast.fail("手机号不能为空");
        return;
      }
      //获取验证码之前需要授权
      if (
        this.formset.openId == undefined ||
        this.formset.openId == null ||
        this.formset.openId == ""
      ) {
        Dialog.alert({
          title: "提示信息",
          message:
            "由于您拒绝了我们获得您的微信姓名信息，因此您无法注册，如需继续注册，请点击下方按钮刷新页面重新授权您的信息给我们！"
        }).then(() => {
          //先授权微信公众号
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            this.GLOBAL.appid +
            "&redirect_uri=" +
            this.GLOBAL.redirect_uri +
            "%23%2Fpage%2Fmdisreg%3Fid%3D" +
            this.companyId +
            "%26disid%3D" +
            this.disid +
            "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
        });
        return;
      }
      const TIME_COUNT = 60;
      if (!this.codetimer) {
        this.waitminutes = TIME_COUNT;
        this.getcodeshow = false;
        this.codetimer = setInterval(() => {
          if (this.waitminutes > 0 && this.waitminutes <= TIME_COUNT) {
            this.waitminutes--;
          } else {
            this.getcodeshow = true;
            clearInterval(this.codetimer);
            this.codetimer = null;
          }
        }, 1000);
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getverificationcode", {
          params: {
            picCode: this.PicCodeValue,
            onceString: this.VerificationCodePic.OnceString,
            telephone: this.user.UserName,
            loginType: this.loginType
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
            } else {
              this.waitminutes = 0;
              this.getpiccode();
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    checkcode: function() {
      if (this.user.UserName == "") {
        Toast.fail("手机号不能为空");
        return;
      }
      if (this.user.Password == "") {
        Toast.fail("验证码不能为空");
        return;
      }
      if (
        this.formset.openId == undefined ||
        this.formset.openId == null ||
        this.formset.openId == ""
      ) {
        Dialog.alert({
          title: "提示信息",
          message:
            "由于您拒绝了我们获得您的微信姓名信息，因此您无法注册，如需继续注册，请点击下方按钮刷新页面重新授权您的信息给我们！"
        }).then(() => {
          //先授权微信公众号
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            this.GLOBAL.appid +
            "&redirect_uri=" +
            this.GLOBAL.redirect_uri +
            "%23%2Fpage%2Fmdisreg%3Fid%3D" +
            this.companyId +
            "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
        });
      }

      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/activeandregsfxs", {
          params: {
            telephone: this.user.UserName,
            code: this.user.Password,
            loginType: this.loginType,
            syscompanyID: this.companyId,
            openId: this.formset.openId,
            disid: this.disid,
            access_token: this.formset.access_token
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              Toast.success("注册成功");
              localStorage.setItem("token", JSON.stringify(rep.Data));
              this.setcache();
              window.location.href = this.GLOBAL.WEB_URL + "/#/app/home";
              //this.$router.push("/app/home");
              //window.location.href =
              //"https://open.weixin.qq.com/connect/oauth2/authorize?appid="+this.GLOBAL.appid+"&redirect_uri="+this.GLOBAL.redirect_uri+"%23%2Fpage%2Fmdisreg&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
              //this.$router.push("/app/home");
            } else {
              this.getpiccode();
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/regmdiss/mdisreg.vue